/**
 * Responsibility: ask before doing something that is annoying to undo.
 *
 * Deliberately generic and deliberately plain: the body says what will happen
 * and what will survive, rather than asking "are you sure?", which is a
 * question nobody reads.
 */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  pending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  pending = false,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText variant="body2">{body}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button size="small" onClick={onCancel}>Cancel</Button>
        <Button size="small" color="error" variant="contained" onClick={onConfirm} disabled={pending}>
          {pending ? 'Working' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
